// Role-specific validation - Uses generic validation utility
import { createValidation } from '../../utils/validation';

/**
 * Role-specific validation factory
 * This is a thin wrapper around the generic validation utility
 * for backwards compatibility with existing role module code
 */
export const createRoleValidation = (fields) => {
  const validation = createValidation(fields);
  
  // Return both generic and specific method names for flexibility
  return {
    schema: validation.schema,
    validateData: validation.validateData, // Generic name for configInit
    validateRoleData: validation.validateData, // Specific name for backwards compatibility
    validateField: validation.validateField
  };
};

// Default export for backwards compatibility
export default createRoleValidation;
